/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ESPSettings} from './ESPSettings';

/**
 * The EspsEspIdBody model module.
 * @module model/EspsEspIdBody
 * @version 1.0.0
 */
export class EspsEspIdBody {
  /**
   * Constructs a new <code>EspsEspIdBody</code>.
   * @alias module:model/EspsEspIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EspsEspIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EspsEspIdBody} obj Optional instance to populate.
   * @return {module:model/EspsEspIdBody} The populated <code>EspsEspIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EspsEspIdBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('settings'))
        obj.settings = ESPSettings.constructFromObject(data['settings']);
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
EspsEspIdBody.prototype.title = undefined;

/**
 * @member {String} description
 */
EspsEspIdBody.prototype.description = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
EspsEspIdBody.TypeEnum = {
  /**
   * value: "ses"
   * @const
   */
  ses: "ses"
};
/**
 * @member {module:model/EspsEspIdBody.TypeEnum} type
 */
EspsEspIdBody.prototype.type = undefined;

/**
 * @member {module:model/ESPSettings} settings
 */
EspsEspIdBody.prototype.settings = undefined;

